import { today } from "@repo/helpers";
import { KeyedArray } from "@repo/models";
import { EditableGridPage, Loading } from "@repo/ui";
import { FC, useCallback, useEffect } from "react";

import { useLocationQueries } from "../../api/locationApi";
import { useLocationContext, useStatusHistoryContext } from "../../contexts/editableItemContext";
import { StatusHistoryProvider } from "../../contexts/editableItemContext";
import { LocationStatus } from "../../models";
import { StatusHistoryEditor } from "./editor";
import { StatusHistoriesGrid } from "./grid";
import style from "./style.module.scss";

export const StatusHistory: FC = () => {
	return (
		<StatusHistoryProvider>
			<section>
				<EditStatusHistories />
			</section>
		</StatusHistoryProvider>
	);
};

function EditStatusHistories() {
	const { locationId, location } = useLocationContext();
	const { item, overwriteItem, pendingChanges } = useStatusHistoryContext();
	const { useStatusHistoriesQuery } = useLocationQueries();
	const { data: statusHistories, loading } = useStatusHistoriesQuery(locationId);

	useEffect(() => {
		if (item?.statusId != null) return;
		if (statusHistories?.length > 0) handleOpen(statusHistories[0]);
	}, [statusHistories]);

	const handleOpen = useCallback(
		(item: LocationStatus) => {
			if (item?.id === location.statusHistory.id) overwriteItem({ ...item, canEdit: true, canEditStatus: false });
			else overwriteItem({ ...item, canEdit: false, canEditStatus: false });
		},
		[overwriteItem, location],
	);

	const newItem = useCallback(() => {
		overwriteItem({
			startDate: today(),
			endDate: null,
			canEdit: true,
			canEditStatus: true,
		} as LocationStatus);
	}, [overwriteItem]);

	const updateRoute = useCallback((key: string) => {}, []);

	const keyedStatusHistories = new KeyedArray<LocationStatus>(statusHistories, (i) => i.id);

	return (
		<Loading loading={loading}>
			<EditableGridPage<LocationStatus>
				id="LocationStatusContainer"
				items={keyedStatusHistories}
				keyProperty="id"
				Editor={StatusHistoryEditor}
				Grid={StatusHistoriesGrid}
				openItem={handleOpen}
				pendingChanges={pendingChanges}
				newItem={newItem}
				newItemText="Add Status History"
				itemsLoaded={loading}
				entityId={item?.id}
				updateRoute={updateRoute}
				gridContainerClassName={style.gridPageContainer}
			/>
		</Loading>
	);
}
